import { reloadWindow } from './reloadWindow.ts';
import { sessionStorage } from './storage/sessionStorage.ts';

export const markTwaLeavingForOAuth = () => {
  if (sessionStorage.getItem('twa') !== null) {
    sessionStorage.setItem('leftTwaForOAuth', true);
  }
};

// Brave hosting the TWA lays out the page the OAuth redirect lands on at
// desktop width, ignoring the viewport meta. A reload restores the mobile layout.
export const reloadOnTwaOAuthReturn = () => {
  if (sessionStorage.getItem('leftTwaForOAuth')) {
    sessionStorage.removeItem('leftTwaForOAuth');
    reloadWindow();
  }
};
